// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"52ca18da","96":"a17f03bb","152":"86bd2093","741":"2d37fa68","873":"26220f47","947":"96e37eaf"}[chunkId] + ".chunk.css";
};